import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api/index.ts";
import {
  trainingAttemptKey,
  trainingHomeKey,
} from "@/lib/api/training-simulator/training-simulator";

export type DevTrainingAction = "complete_attempt" | "reset" | "reset_modules";

interface DevTrainingActionInput {
  action: DevTrainingAction;
  attemptId?: string;
}

/**
 * Dev-only helper that drives the single guarded
 * `POST v2/training-simulator/dev/action` endpoint. Calls are gated behind
 * non-production environments at the call site (see TrainingDevPanel).
 */
export const useDevTrainingAction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["training-simulator", "dev-action"],
    mutationFn: async ({
      action,
      attemptId,
    }: DevTrainingActionInput) => {
      await fetchApi<unknown>({
        url: "v2/training-simulator/dev/action",
        method: "POST",
        data: { action, attemptId },
      });
    },
    onSuccess: (_data, { attemptId }) => {
      queryClient.invalidateQueries({ queryKey: trainingHomeKey });
      if (attemptId) {
        queryClient.invalidateQueries({
          queryKey: trainingAttemptKey(attemptId),
        });
      }
    },
  });
};
